// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Private Reply modal — admin DM fan-out to public comment */

.prm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2200;
}

.prm-modal {
  background: #ffffff;
  border-radius: 10px;
  width: min(520px, 92vw);
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.prm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eceff3;
}

.prm-header h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1b1f26;
}

.prm-close {
  background: transparent;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;
  color: #7a808b;
  padding: 0 4px;
}

.prm-close:hover {
  color: #1b1f26;
}

.prm-body {
  padding: 16px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.prm-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #525863;
  margin-top: 4px;
}

.prm-original-comment {
  background: #f5f7fa;
  border: 1px solid #e0e4ea;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.9rem;
  color: #2b313a;
  white-space: pre-wrap;
  word-break: break-word;
}

.prm-textarea {
  width: 100%;
  border: 1px solid #d5dae2;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.92rem;
  font-family: inherit;
  resize: vertical;
  min-height: 90px;
}

.prm-textarea:focus {
  outline: none;
  border-color: #4a7cff;
  box-shadow: 0 0 0 3px rgba(74, 124, 255, 0.18);
}

.prm-feedback {
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
}

.prm-feedback-success {
  background: #e6f5ea;
  color: #1a6b34;
}

.prm-feedback-error {
  background: #fdecec;
  color: #8f1e1e;
}

.prm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #eceff3;
  background: #fafbfd;
}

.prm-btn {
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 0.88rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.prm-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.prm-btn-cancel {
  background: #eceff3;
  color: #2b313a;
}

.prm-btn-cancel:hover:not(:disabled) {
  background: #dde2e8;
}

.prm-btn-send {
  background: #4a7cff;
  color: #ffffff;
}

.prm-btn-send:hover:not(:disabled) {
  background: #3a68e8;
}
`, "",{"version":3,"sources":["webpack://./src/components/PrivateReplyModal.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Private Reply modal — admin DM fan-out to public comment */\n\n.prm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2200;\n}\n\n.prm-modal {\n  background: #ffffff;\n  border-radius: 10px;\n  width: min(520px, 92vw);\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.prm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  border-bottom: 1px solid #eceff3;\n}\n\n.prm-header h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #1b1f26;\n}\n\n.prm-close {\n  background: transparent;\n  border: none;\n  font-size: 1.6rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #7a808b;\n  padding: 0 4px;\n}\n\n.prm-close:hover {\n  color: #1b1f26;\n}\n\n.prm-body {\n  padding: 16px 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.prm-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #525863;\n  margin-top: 4px;\n}\n\n.prm-original-comment {\n  background: #f5f7fa;\n  border: 1px solid #e0e4ea;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 0.9rem;\n  color: #2b313a;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.prm-textarea {\n  width: 100%;\n  border: 1px solid #d5dae2;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 0.92rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 90px;\n}\n\n.prm-textarea:focus {\n  outline: none;\n  border-color: #4a7cff;\n  box-shadow: 0 0 0 3px rgba(74, 124, 255, 0.18);\n}\n\n.prm-feedback {\n  padding: 8px 10px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n}\n\n.prm-feedback-success {\n  background: #e6f5ea;\n  color: #1a6b34;\n}\n\n.prm-feedback-error {\n  background: #fdecec;\n  color: #8f1e1e;\n}\n\n.prm-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 12px 20px;\n  border-top: 1px solid #eceff3;\n  background: #fafbfd;\n}\n\n.prm-btn {\n  padding: 8px 18px;\n  border-radius: 6px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n}\n\n.prm-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.prm-btn-cancel {\n  background: #eceff3;\n  color: #2b313a;\n}\n\n.prm-btn-cancel:hover:not(:disabled) {\n  background: #dde2e8;\n}\n\n.prm-btn-send {\n  background: #4a7cff;\n  color: #ffffff;\n}\n\n.prm-btn-send:hover:not(:disabled) {\n  background: #3a68e8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
